<div class="modal-header" mat-dialog-title>
    <h5 class="modal-title">Remove Image</h5>
    <a class="modal-close" mat-dialog-close>&#10005;</a>
</div>
<mat-dialog-content class="mat-remove-image">
    <div class="code-section">
        <p><strong>Mailing:</strong> {{dailogData.mailingID}}</p>
        <p><strong>Specimen:</strong> {{dailogData.specimenCode}}</p>
    </div>
        <div class="modal-body">
        <p class="remove-des">Are you sure you would like to remove <strong>{{dailogData.name}}</strong>? This action cannot be undone.</p>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions" align="start">
    <button mat-button class="save-btn" (click)="onClickRemoveImage()">Remove Image</button>
    <button mat-button mat-dialog-close class="cancel-btn">Cancel</button>
</mat-dialog-actions>